module.exports = __webpack_public_path__ + "img/bindlbf.9c0b49e7.png";